module.exports = __webpack_public_path__ + "img/step6-01.b4291838.jpg";